import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { request } from "@/lib/request";
import { normalizeRequestError } from "@/lib/errors";
import { Team } from "@/lib/types";
import { useUser } from "../useUserProvider";

export const useGetUserTeams = (
  options: Omit<UseQueryOptions<Team[], Error>, "queryKey" | "queryFn"> = {},
) => {
  const { accessToken } = useUser();

  return useQuery({
    ...options,
    queryKey: ["user", accessToken, "teams"],
    enabled: !!accessToken && (options.enabled ?? true),
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("You need to be logged in to fetch teams.");
      }

      const res = await request
        .get(`/user/teams`)
        .catch(normalizeRequestError("Failed to fetch teams."));

      return res.data.data;
    },
  });
};
